import {useEffect} from "react"
import { useSelector, useDispatch } from "react-redux"

import { RightMenu, LeftMenu, ScheduleButtons } from "components"
import ScheduleScreenContent from "./ScheduleScreenContent"

import "./index.scss"
import { constraintChecks } from "state_management"

function UpdateActions(){
  const dispatch = useDispatch()
  const actions = useSelector((state) => state.projectActions.plannedProjectActions)
  const tasks = useSelector((state) => state.analysisTasks)
  useEffect(() => {constraintChecks.allConstraintChecks(dispatch)}, [actions, tasks]) // eslint-disable-line react-hooks/exhaustive-deps
  return (<div></div>)
}

export default function ScheduleScreen() {
  const isMember = useSelector((state) => state.auth.isMember)
  const isViewOnly = useSelector((state) => state.auth.isViewOnly)
  const allowTaskTransfer = useSelector((state) => state.teamStatus.allowTaskTransfer)
  const memberId = useSelector((state) => state.auth.memberId)
  const allMembers = useSelector((state) => state.members)
  const currentMemberShowOnPlan = useSelector((state) => memberId && state.members[memberId] ? state.members[memberId].showOnPlan : true)

  const rightMenuVisible = useSelector((state) => state.visual.rightMenuVisible)
  const leftMenuVisible = useSelector((state) => state.visual.leftMenuVisible)
  const showRightMenu = useSelector((state) => state.teamStatus.showProjects || state.teamStatus.showAnalyses)
  // SPEC-066 (#4180): the right panel (unplanned analyses / projects) is visible to VIEW_ONLY too —
  // they may see and open what is waiting, never move it; the menus gate every interaction
  // themselves. The left menu (IAP) stays planner-only below.
  const showSidebars = !isMember || currentMemberShowOnPlan || allowTaskTransfer

  const members = Object.values(allMembers).filter((member) => member.showOnPlan)
  return (
    <div className="ScheduleScreen">
      {!isMember && !isViewOnly && <LeftMenu open={leftMenuVisible} />}
      {showRightMenu && showSidebars && <RightMenu open={rightMenuVisible} />}
      <ScheduleButtons type="team-plan" moveLeft={leftMenuVisible} moveRight={rightMenuVisible && showRightMenu && showSidebars} />
      <ScheduleScreenContent
        members={members}
        moveLeft={leftMenuVisible}
        moveRight={rightMenuVisible && showRightMenu && showSidebars}
      />
      <UpdateActions />
    </div>
  )
}
